import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { bell_01 } from "@tql/ui-components-react/untitled/icons";
import type { KeyboardEvent } from "react";

import { useKeyDown } from "../../hooks/use-key-down.ts";
import styles from "./exceptions-indicator.module.css";

export const ExceptionIndicator = ({
	count,
	exceptionType,
	onClickSummaryCard,
	isActive = false,
}: {
	count: number;
	exceptionType: string;
	onClickSummaryCard: (status: string, exceptions: boolean) => void;
	isActive?: boolean;
}) => {
	const { handleKeyDown } = useKeyDown(onClickSummaryCard);
	const visibilityClass =
		count > 0 ? styles.iconBoxVisible : styles.iconBoxHidden;

	return (
		<div
			aria-label={`Filter to show ${exceptionType} shipments`}
			className={`${styles.iconBox} ${visibilityClass} ${isActive ? styles.active : ""}`}
			onClick={(e) => {
				e.stopPropagation();
				onClickSummaryCard?.(exceptionType, true);
			}}
			onKeyDown={(e: KeyboardEvent<Element>) =>
				handleKeyDown(e, exceptionType, true)
			}
			role={"button"}
			tabIndex={0}
		>
			<SvgIcon icon={bell_01} />
			<span className={styles.iconNumber}>{count}</span>
		</div>
	);
};
